import { render, staticRenderFns } from "./issue.vue?vue&type=template&id=ee8a7088&scoped=true&"
import script from "./issue.vue?vue&type=script&lang=js&"
export * from "./issue.vue?vue&type=script&lang=js&"
import style0 from "./issue.vue?vue&type=style&index=0&id=ee8a7088&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8a7088",
  null
  
)

export default component.exports